class KitsSubscriptionSlider extends HTMLElement {
  constructor () {
    super();
    this.swiper = null;
  }

  connectedCallback () {
    this.swiperEl = this;
    this.initSwiper();
  }

  initSwiper () {
    if (!this.swiperEl) return;

    const initOrDestroy = () => {
      const isMobile = window.matchMedia('(max-width: 991px)').matches;

      if (isMobile && !this.swiper) {
        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: 1.1,
          breakpoints: {
            575: {
              slidesPerView: 2.2,
            }
          },
          spaceBetween: 22
        });
      } else if (!isMobile && this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    };

    initOrDestroy();
    window.addEventListener('resize', initOrDestroy);
  }

  disconnectedCallback() {
    if (this.swiper && !this.swiper.destroyed) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('kits-subscription-slider')) {
  customElements.define('kits-subscription-slider', KitsSubscriptionSlider)
}